<mat-sidenav-container fullscreen>
  @if (!utilityService.isShowSimplifiedheader) {
    <mat-sidenav [opened]="false" mode="over" #start class="sidenav">
      <div class="d-flex header p-5 fx-row">
        <div class="move-left avtar fx-row fx-main-start fx-cross-center fx-flex-10 xs-fx-flex-15">
          <img class="avtar"
            [default]="'assets/img/user.png'"
            [src]="userServiceModal.customerData.ImageUrl || userServiceModal.enrollerInfo.ImageUrl" />
        </div>
        <div class="ds_userName fx-row fx-main-start fx-cross-center fx-flex-35">
          <h2
            [textContent]="((userServiceModal.customerData.FirstName || userServiceModal.customerData.LastName)? welcmtext  :'') + ' ' + (userServiceModal.customerData.FirstName || userServiceModal.enrollerInfo.FirstName) + ' ' + (userServiceModal.customerData.LastName || userServiceModal.enrollerInfo.LastName)"
          class="f-s-22 text-uppercase"></h2>
        </div>
        <div class="fx-row fx-main-end fx-cross-center fx-flex-55">
          <button mat-icon-button color="warn" class="close" (click)="start.close()">
            <mat-icon color="warn">close</mat-icon>
          </button>
        </div>
      </div>
      <div class="sidebar-items" class="p-16 fx-col">
        @for (item of navItems; track item) {
          <app-sidebar [item]="item" (click)="close(item)" (close)="closed(val)" ></app-sidebar>
        }
      </div>
    </mat-sidenav>
  }
  <!-- topbar start -->
  @if (!utilityService.isShowSimplifiedheader) {
    <mat-toolbar class="bgm-black">
      <mat-toolbar-row class="top-bar p-5 fx-row fx-main-between fx-cross-center">
        <div class="welcome-message fx-row" mat-button [matMenuTriggerFor]="enrollMenu">
          <div class="widget-text">
            <!-- Enroller Picture -->
            <div  class="enroll_img fx-row fx-main-center fx-cross-center">
              <div>
                <a class="avtar">
                  <img style="height:45px;width:45px;" [src]="userServiceModal.enrollerInfo.ImageUrl" alt="companylogo"
                    [default]="'assets/images/user.png'">
                  </a>
                </div>
                <div>
                  <button mat-button class="p-5 c-white">
                    <div class="shop_heading text-nonecase edb-space" translate="you_r_shop_with">
                    </div>
                    @if (true) {
                      <span>
                        <span class="text-uppercase f-500 xs-ew-font-size-12px" data-bind="label">{{userServiceModal.enrollerInfo.FirstName}}
                        &nbsp;{{userServiceModal.enrollerInfo.LastName}}</span>
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                      </span>
                    }
                  </button>
                </div>
              </div>
              <mat-menu #enrollMenu="matMenu">
                <button  mat-menu-item routerLink="/contact" >{{"contact_" | translate}}</button>
                @if (!isLoggedIn()) {
                  <button mat-menu-item (click)="navigateToChangeAffiliate();">{{'market_change_affiliate'|
                  translate}}</button>
                }
              </mat-menu>
            </div>
          </div>
          <div class="widgets-left fx-row">
            @if (!isLoggedIn()) {
              <div class="widget-text" [matMenuTriggerFor]="menu">
                <button mat-button  class="c-white">
                  <div class="shop_heading text-nonecase edb-space" translate="you_r_shopping_as">
                  </div>
                  <span class="text-uppercase f-500 text-truncate customer_type xs-ew-font-size-12px" data-bind="label">{{configService.commonSettings.CustomerTypes.Description}}</span>
                  <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @for (customerType of configService.commonSettings.CustomerTypes; track customerType) {
                    <button mat-menu-item
                    (click)="changeCustomerType(customerType.ID)">{{customerType.Description | translate}}</button>
                  }
                </mat-menu>
              </div>
            }
            <div class="vl"></div>
            <div class="widget-text m-t-10" [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger">
              <a class="flag-icon" mat-button >
                <img [src]="'https://directscalestring.directscale.com/flags/4x3/'+ $safeNavigationMigration(configService.commonData.selectedCountry?.toLowerCase()) +'.svg'" width="18">
                <span class="flag-menu-title c-white print-fx-hide lt-md-fx-hide">{{configService.commonData.selectedCountry | uppercase}} | {{configService.commonData.selectedLanguage | uppercase}}</span>
                <mat-icon iconPositionEnd class="mat-icon-sm caret cur-icon c-white">arrow_drop_down</mat-icon>
              </a>
              <mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown">
                @for (country of allowedCountries; track country) {
                  <span>
                    @for (lng of country.CountryLanguages; track lng) {
                      <button mat-menu-item (click)="updatecountry(country, lng.LanguageCode)"
                        >
                      <img [src]="'https://directscalestring.directscale.com/flags/4x3/'+country.CountryCode+'.svg'"
                        width="18"> {{country.CountryName}} | {{lng.LanguageName}}
                      </button>
                    }
                  </span>
                }
              </mat-menu>
            </div>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
    }
    @if (!utilityService.isShowSimplifiedheader) {
      <app-header (sildeMobileNavEvent)="sildeMobileNav($event)">
      </app-header>
    }
    <router-outlet></router-outlet>

    <app-footer></app-footer>

  </mat-sidenav-container>